import { Button, Tooltip } from '@mui/material'
import { reportErrorToConsole } from '@src/services/error-logger'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'

const LanguagePicker = (): JSX.Element => {
  const { i18n, t } = useTranslation()

  const handleChangeLanguage = () => {
    i18n.changeLanguage(i18n.resolvedLanguage === 'fr' ? 'en' : 'fr').catch(reportErrorToConsole)
  }

  return (
    <Tooltip title={t('menus.targetLanguageLong')}>
      <Button onClick={handleChangeLanguage}>{t('menus.targetLanguage')}</Button>
    </Tooltip>
  )
}

export default LanguagePicker
